import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const unbalanceApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUnbalances: builder.query({
            query: ({ page, limitNumber, params }) => {
                return {
                    url: `/bouser/balance/${page}/params`,
                    params: { limitNumber, ...removeEmptyKeys(params) },
                }
            },
            transformResponse: (response, meta, args) => {
                let parsedUnbalances = response.detailsList.map((balance) => {
                    return {
                        ...balance
                    }
                })
                return {
                    rows: parsedUnbalances,
                    count: response.count,
                    pages: response.pages,
                }
            },
            providesTags: ['bouser'],
        }),
        getUnbalanceById: builder.query({
            query: (payload) => {
                const { page = 1, params = {}, limitNumber = 50 } = payload
                return {
                    url: `/bouser/balance/unbalancebyid/${params.unbalanceid}`,
                    method: 'GET'
                }
            },
            transformResponse: (response, meta, args) => {
                let parsedBoUsers = response
                return {
                    rows: parsedBoUsers,
                    count: response.count,
                    pages: response.pages,
                }
            },
            providesTags: ['unbalances'],
        }),
        toggleUnbalanceAble: builder.mutation({
            query: ({ id: bouserid, able }) => {
                return {
                    url: '/bouser/able',
                    method: 'PUT',
                    body: { bouserid: bouserid, able: able ? 'true' : 'false' },
                }
            },
            invalidatesTags: ['bouser'],
        }),
        createUnbalance: builder.mutation({
            /**
             * creates a new BOUser and sends and invitation email to the user, the user must accept the invitation and finish the registration process
             * @param {*} param0
             * @returns
             */
            query: ({ firstname, lastname, email, roleid }) => {
                return {
                    url: '/bouser/',
                    method: 'POST',
                    body: {
                        user: { firstname, lastname, email },
                        roles: [{ roleid: roleid }],
                    },
                }
            },
            invalidatesTags: ['bouser'],
        }),
        registerUnbalance: builder.mutation({
            /**
             * finish the registration of a new bouser accesible after the invitation email
             * @param {*} param0
             * @returns
             */
            query: ({ phone, password, twofa }) => {
                return {
                    url: '/bouser/',
                    method: 'PUT',
                    body: { user: { phone, password, twofa } },
                }
            },
            invalidatesTags: ['bouser'],
        }),
        updateUnbalance: builder.mutation({
            /**
             * Update of unabalance data from a different user with an authorized role
             * @param {object} - user data
             * @returns
             */
            query: ({ unbalanceid }) => {
                return {
                    url: '/bouser/balance/unbalanceupdate',
                    method: 'PUT',
                    body: { unbalanceid: unbalanceid },
                }
            },
            invalidatesTags: ['unbalances'],
        }),
        burnUnbalance: builder.mutation({
            /**
             * burn of unabalance data 
             * @param {object} - bc transaction
             * @returns
             */
            query: ({ unbalanceid, bctransaction }) => {
                return {
                    url: '/bouser/balance/unbalanceburn',
                    method: 'PUT',
                    body: { unbalanceid, bctrans: bctransaction },
                }
            },
            invalidatesTags: ['unbalances'],
        }),
        revertUnbalance: builder.mutation({
            /**
             * revert of unabalance data 
             * @param {object} - bc transaction
             * @returns
             */
            query: ({ unbalanceid, nromov, txhash }) => {
                return {
                    url: '/bouser/balance/unbalancerevert',
                    method: 'PUT',
                    body: { unbalanceid: unbalanceid, nromov: nromov, txhash: txhash },
                }
            },
            invalidatesTags: ['unbalances'],
        }),
        sendUnbalanceNotification: builder.mutation({
            /**
             * Resend Notification email to a user
             * @param {object} - bctransaction
             */
            query: ({ unbalanceid, bctransaction }) => {
                return {
                    url: '/bouser/balance/sendnotification',
                    method: 'PUT',
                    body: { unbalanceid, bctrans: bctransaction },
                }
            }
        })
    }),
    overrideExisting: true,
})

export const {
    useGetUnbalancesQuery,
    useGetUnbalanceByIdQuery,
    useToggleUnbalanceAbleMutation,
    useCreateUnbalanceMutation,
    useRegisterUnbalanceMutation,
    useUpdateUnbalanceMutation,
    useBurnUnbalanceMutation,
    useRevertUnbalanceMutation,
    useSendUnbalanceNotificationMutation,
} = unbalanceApiSlice
